import { DataGridActiveColumns } from '@virtus/components/DataGrid/models';

export const ErrorDetailsActiveColumns: DataGridActiveColumns = {
  //ErrorId: false,
  ErrorMessage: true,
  //ErrorSeverity: false,
  MethodName: true,
  ModuleName: true,
  MachineName: true,
  StackTrace: false,
  LoggedUserId: true,
  ExceptionOriginationDate: true,
  SignalRClientId: false,
  HttpHeader: false,
};

export const ErrorDetailHeaders = [
  {
    caption: 'Error Date Time',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'ExceptionOriginationDate',
    dataType: 'datetimeutc',
  },
  {
    caption: 'Module',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'ModuleName',
    dataType: 'string',
  },
  {
    caption: 'Method',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'MethodName',
    dataType: 'string',
  },
  {
    caption: 'Message',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'ErrorMessage',
    dataType: 'string',
    width: 690,
  },
  {
    caption: 'Machine',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'MachineName',
    dataType: 'string',
  },
  {
    caption: 'User',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'LoggedUserId',
    dataType: 'string',
  },
];

export const ErrorDetailsBaseColumns = {
  // ErrorId: {
  //   field: 'ErrorId',
  //   filterPlaceholder: 'Search Error ID',
  //   width: '100',
  // },
  ExceptionOriginationDate: {
    field: 'ExceptionOriginationDate',
    filterPlaceholder: 'Search Error Date Time',
    template: 'DateTimeTpl',
    Filter: 'DateFilter',
  },
  ModuleName: {
    field: 'ModuleName',
    filterPlaceholder: 'Search Module Name',
  },
  MethodName: {
    field: 'MethodName',
    filterPlaceholder: 'Search Method Name',
  },
  ErrorMessage: {
    field: 'ErrorMessage',
    filterPlaceholder: 'Search Error Message',
    width: 690,
  },
  MachineName: {
    field: 'MachineName',
    filterPlaceholder: 'Search Machine',
  },
  LoggedUserId: {
    field: 'LoggedUserId',
    filterPlaceholder: 'Search User',
  },
  // ErrorSeverity: {
  //   field: 'ErrorSeverity',
  //   filterPlaceholder: 'Search Error Severity',
  //   width: '100',
  // },
  StackTrace: {},
  SignalRClientId: {},
};
